document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.basic-header').forEach(function (header) {
    var searchToggle = header.querySelector('[data-search-toggle]');
    var searchPanel = header.querySelector('[data-search-panel]');
    var searchInput = header.querySelector('[data-search-input]');

    if (searchToggle && searchPanel) {
      searchToggle.addEventListener('click', function () {
        var isOpen = searchPanel.classList.toggle('is-open');
        searchToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        if (isOpen && searchInput) {
          setTimeout(function () {
            searchInput.focus();
          }, 200);
        }
      });
    }

    var menuToggle = header.querySelector('[data-mobile-menu-toggle]');
    var menuPanel = header.querySelector('[data-mobile-menu-panel]');

    if (menuToggle && menuPanel) {
      menuToggle.addEventListener('click', function () {
        var isOpen = menuPanel.classList.toggle('is-open');
        menuToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    }
  });
});
